import React from 'react';
import { getMobileAppLink } from 'helpers';
import { ReactComponent as InsuranceIcon } from 'products/nomad_insurance/assets/img/icons/menu/insurance.svg';
import { ReactComponent as FaqIcon } from 'products/nomad_insurance/assets/img/icons/menu/faq.svg';
import { ReactComponent as AppIcon } from 'products/nomad_insurance/assets/img/icons/mobile.svg';

export const generateMenuItems = (onClose) => {
  const items = [
    {
      label: 'My insurance',
      onClick: onClose,
      url: '/nomad-insurance/profile',
      icon: <InsuranceIcon />,
      variant: 'myInsurance'
    }
  ];

  return items;
};

export const generateMoreInfoItems = (onClose) => [
  {
    label: 'FAQ',
    onClick: onClose,
    url: '/nomad-insurance/faq',
    icon: <FaqIcon />
  },
  {
    label: 'Download mobile app',
    externalUrl: getMobileAppLink(),
    icon: <AppIcon />
  }
];
